/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendChartDto } from '../models/backend-chart-dto';
import { BackendDataDto } from '../models/backend-data-dto';
import { BackendMessageDto } from '../models/backend-message-dto';
import { monitoringComparisonsBalanceRetrieve } from '../fn/monitoring-comparisons/monitoring-comparisons-balance-retrieve';
import { MonitoringComparisonsBalanceRetrieve$Params } from '../fn/monitoring-comparisons/monitoring-comparisons-balance-retrieve';
import { monitoringComparisonsCashFlowRetrieve } from '../fn/monitoring-comparisons/monitoring-comparisons-cash-flow-retrieve';
import { MonitoringComparisonsCashFlowRetrieve$Params } from '../fn/monitoring-comparisons/monitoring-comparisons-cash-flow-retrieve';
import { monitoringComparisonsChartDataRetrieve } from '../fn/monitoring-comparisons/monitoring-comparisons-chart-data-retrieve';
import { MonitoringComparisonsChartDataRetrieve$Params } from '../fn/monitoring-comparisons/monitoring-comparisons-chart-data-retrieve';
import { monitoringComparisonsCoefficientsRetrieve } from '../fn/monitoring-comparisons/monitoring-comparisons-coefficients-retrieve';
import { MonitoringComparisonsCoefficientsRetrieve$Params } from '../fn/monitoring-comparisons/monitoring-comparisons-coefficients-retrieve';
import { monitoringComparisonsProfitLossRetrieve } from '../fn/monitoring-comparisons/monitoring-comparisons-profit-loss-retrieve';
import { MonitoringComparisonsProfitLossRetrieve$Params } from '../fn/monitoring-comparisons/monitoring-comparisons-profit-loss-retrieve';
import { monitoringComparisonsSalesRetrieve } from '../fn/monitoring-comparisons/monitoring-comparisons-sales-retrieve';
import { MonitoringComparisonsSalesRetrieve$Params } from '../fn/monitoring-comparisons/monitoring-comparisons-sales-retrieve';
import { monitoringComparisonsUpdateCalculationsCreate } from '../fn/monitoring-comparisons/monitoring-comparisons-update-calculations-create';
import { MonitoringComparisonsUpdateCalculationsCreate$Params } from '../fn/monitoring-comparisons/monitoring-comparisons-update-calculations-create';
import { monitoringFinanceDataForChartsRetrieve } from '../fn/monitoring-comparisons/monitoring-finance-data-for-charts-retrieve';
import { MonitoringFinanceDataForChartsRetrieve$Params } from '../fn/monitoring-comparisons/monitoring-finance-data-for-charts-retrieve';

@Injectable({ providedIn: 'root' })
export class BackendApiMonitoringComparisonsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `monitoringComparisonsBalanceRetrieve()` */
  static readonly MonitoringComparisonsBalanceRetrievePath = '/api/monitoring/comparisons/balance/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringComparisonsBalanceRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringComparisonsBalanceRetrieve$Response(
    params: MonitoringComparisonsBalanceRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDataDto>> {
    return monitoringComparisonsBalanceRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringComparisonsBalanceRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringComparisonsBalanceRetrieve(
    params: MonitoringComparisonsBalanceRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendDataDto> {
    return this.monitoringComparisonsBalanceRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDataDto>): BackendDataDto => r.body),
    );
  }

  /** Path part for operation `monitoringComparisonsCashFlowRetrieve()` */
  static readonly MonitoringComparisonsCashFlowRetrievePath = '/api/monitoring/comparisons/cash-flow/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringComparisonsCashFlowRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringComparisonsCashFlowRetrieve$Response(
    params: MonitoringComparisonsCashFlowRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDataDto>> {
    return monitoringComparisonsCashFlowRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringComparisonsCashFlowRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringComparisonsCashFlowRetrieve(
    params: MonitoringComparisonsCashFlowRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendDataDto> {
    return this.monitoringComparisonsCashFlowRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDataDto>): BackendDataDto => r.body),
    );
  }

  /** Path part for operation `monitoringComparisonsChartDataRetrieve()` */
  static readonly MonitoringComparisonsChartDataRetrievePath = '/api/monitoring/comparisons/chart-data/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringComparisonsChartDataRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringComparisonsChartDataRetrieve$Response(
    params: MonitoringComparisonsChartDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendChartDto>> {
    return monitoringComparisonsChartDataRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringComparisonsChartDataRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringComparisonsChartDataRetrieve(
    params: MonitoringComparisonsChartDataRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendChartDto> {
    return this.monitoringComparisonsChartDataRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendChartDto>): BackendChartDto => r.body),
    );
  }

  /** Path part for operation `monitoringComparisonsCoefficientsRetrieve()` */
  static readonly MonitoringComparisonsCoefficientsRetrievePath =
    '/api/monitoring/comparisons/coefficients/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringComparisonsCoefficientsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringComparisonsCoefficientsRetrieve$Response(
    params: MonitoringComparisonsCoefficientsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDataDto>> {
    return monitoringComparisonsCoefficientsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringComparisonsCoefficientsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringComparisonsCoefficientsRetrieve(
    params: MonitoringComparisonsCoefficientsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendDataDto> {
    return this.monitoringComparisonsCoefficientsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDataDto>): BackendDataDto => r.body),
    );
  }

  /** Path part for operation `monitoringComparisonsProfitLossRetrieve()` */
  static readonly MonitoringComparisonsProfitLossRetrievePath =
    '/api/monitoring/comparisons/profit-loss/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringComparisonsProfitLossRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringComparisonsProfitLossRetrieve$Response(
    params: MonitoringComparisonsProfitLossRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDataDto>> {
    return monitoringComparisonsProfitLossRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringComparisonsProfitLossRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringComparisonsProfitLossRetrieve(
    params: MonitoringComparisonsProfitLossRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendDataDto> {
    return this.monitoringComparisonsProfitLossRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDataDto>): BackendDataDto => r.body),
    );
  }

  /** Path part for operation `monitoringComparisonsSalesRetrieve()` */
  static readonly MonitoringComparisonsSalesRetrievePath = '/api/monitoring/comparisons/sales/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringComparisonsSalesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringComparisonsSalesRetrieve$Response(
    params: MonitoringComparisonsSalesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDataDto>> {
    return monitoringComparisonsSalesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringComparisonsSalesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringComparisonsSalesRetrieve(
    params: MonitoringComparisonsSalesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendDataDto> {
    return this.monitoringComparisonsSalesRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDataDto>): BackendDataDto => r.body),
    );
  }

  /** Path part for operation `monitoringComparisonsUpdateCalculationsCreate()` */
  static readonly MonitoringComparisonsUpdateCalculationsCreatePath =
    '/api/monitoring/comparisons/update-calculations/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringComparisonsUpdateCalculationsCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringComparisonsUpdateCalculationsCreate$Response(
    params: MonitoringComparisonsUpdateCalculationsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMessageDto>> {
    return monitoringComparisonsUpdateCalculationsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringComparisonsUpdateCalculationsCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringComparisonsUpdateCalculationsCreate(
    params: MonitoringComparisonsUpdateCalculationsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendMessageDto> {
    return this.monitoringComparisonsUpdateCalculationsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMessageDto>): BackendMessageDto => r.body),
    );
  }

  /** Path part for operation `monitoringFinanceDataForChartsRetrieve()` */
  static readonly MonitoringFinanceDataForChartsRetrievePath = '/api/monitoring/finance_data_for_charts/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringFinanceDataForChartsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringFinanceDataForChartsRetrieve$Response(
    params: MonitoringFinanceDataForChartsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendChartDto>> {
    return monitoringFinanceDataForChartsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringFinanceDataForChartsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringFinanceDataForChartsRetrieve(
    params: MonitoringFinanceDataForChartsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendChartDto> {
    return this.monitoringFinanceDataForChartsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendChartDto>): BackendChartDto => r.body),
    );
  }
}
